import {PERSIST_STATE_CHANGE} from '../actions/actionTypes'

export default function reduce(state={}, action)
{
    switch(action.type)
    {
        case PERSIST_STATE_CHANGE:
            let persistedLocation = action.payload.path;
            let persistedState = action.payload.state;
            let name = action.payload.name;

            let newState = Object.assign({}, state[name], {
                [persistedLocation] : persistedState
            });

            return Object.assign({}, state, {
                [name] : newState
            });

        default: 
            return state;
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/persistence/src/reducers/index.js